import { HStack, Header, Text, VStack, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { primitive } from 'styles/constants';
import { WEB_APP_MODAL_CONTENT_MAX_WIDTH } from 'utils/constants';

const commonMarginTop = '$4';

export const DisclaimerText = Text.withConfig({
  marginTop: commonMarginTop,
  focusable: true,
  textAlign: 'center',
  color: primitive.$bbqBrown,
});

export const StyledActionButton = makeUclComponent(ActionButton).withConfig({
  marginTop: commonMarginTop,
});

export const ActionButtonOutline = StyledActionButton.withConfig({
  marginTop: commonMarginTop,
  _text: {
    color: primitive.$bbqBrown,
  },
  borderColor: primitive.$bbqBrown,
  variant: ActionButtonVariants.OUTLINE,
});

export const Container = VStack.withConfig({
  paddingY: '$9',
  paddingX: '$4',
  maxWidth: WEB_APP_MODAL_CONTENT_MAX_WIDTH,
  width: 'full',
});

export const StoreAddressText = Text.withConfig({
  flex: 1,
  numberOfLines: 1,
  overflow: 'hidden',
  fontSize: 'md',
  color: primitive.$bbqBrown,
  fontFamily: 'body',
  _web: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const HeaderText = makeUclComponent(Header).withConfig({
  _web: {
    fontSize: {
      base: 'xl',
      md: '2xl',
    },
  },
  margin: 0,
  textAlign: 'center',
  accessible: true,
  accessibilityRole: 'header',
});

export const DistanceText = Text.withConfig({
  fontSize: 'sm',
  fontFamily: 'heading',
  lineHeight: 'xs',
});

export const StoreDetailsContainer = HStack.withConfig({
  marginTop: commonMarginTop,
  alignItems: 'center',
  borderTopWidth: 1,
  borderBottomWidth: 1,
  borderColor: primitive.$blackOpacity10,
  paddingX: '$3',
  paddingY: '$2',
  justifyContent: 'space-between',
});
